import { AxiosError } from 'axios';
import { useContext, useState } from 'react';
import toast from 'react-hot-toast';

import { TableContext } from '../../../components/Table/TableContext';
import { ErrorHttpResponse, HttpConfig, SuccessHttpResponse } from '../../../models/https';
import useHttps from '../../useHttps';

const useRejectKyc = () => {
    const request = useHttps();
    const [loading, setLoading] = useState(false);
    const [showSuccessModal, setShowSuccessModal] = useState(false);
    const tableContext = useContext(TableContext);


    const onRejectKycError = (err: AxiosError<ErrorHttpResponse>) => {
        toast.error(
            err?.response?.data?.message ?? 'Something went wrong while rejecting kyc.',
        );
        // setShowSuccessModal(true);
    };

    const onRejectKycSuccess = ({
        data,
        message,
    }: SuccessHttpResponse<any>) => {
        setShowSuccessModal(true);
        tableContext?.setRefreshTable(!tableContext?.refreshTable);
    };

    const rejectKyc = async (companyId: any) => {
        const url: HttpConfig = {
            url: `ba/v1/company/${companyId}/kyc/reject`,
            method: 'put',
            // data: data
        };

        await request(url, onRejectKycSuccess, setLoading, onRejectKycError);
    };

    return { rejectKyc, loading, showSuccessModal, setShowSuccessModal };
};

export default useRejectKyc;
